import QueryWhereNode from '~/scripts/services/model/query-where-node';

export default class QueryBuilderNodeNameController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} KTranslate
	 */
	constructor($scope, $timeout, KTranslate) {
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.KTranslate = KTranslate;
		/** @type {import('../query-builder-children/query-builder-children.controller').default | undefined} */
		this.builderChildren = undefined;
		this.name = undefined;

		/** @type {import('~/scripts/services/model/query-where-node').default | 'self'} */
		this.node = 'self';
	}

	isChildren() {
		if (this.node instanceof QueryWhereNode) {
			return this.node.inherits_extended === 0;
		}
		else if (this.node === 'self' && this.builderChildren?.parent?.group?.node instanceof QueryWhereNode) {
			return this.builderChildren.parent.group.node.inherits_extended === 0;
		}
		return false;
	}

	/**
	 * @param {any} changes
	 */
	$onChanges(changes) {
		if (changes.node) {
			const node = this.node === 'self'
				? (
					this.builderChildren?.parent?.group?.node instanceof QueryWhereNode
						? this.builderChildren.parent.group.node
						: undefined
				)
				: this.node;

			(async () => {
				if (node) {
					this.name = node.class_kid ? (await this.KTranslate.request(this.$scope, node.kid)) : node.name;
					const {
						linker_kid:  linkerKid,
						linker_info: linkerInfo,
					} = node;
					if (linkerKid !== '0') {
						this.name += ` :: ${linkerInfo?.name || await this.KTranslate.request(this.$scope, linkerKid)}`;
					}
					this.$timeout(() => {
						this.$scope.$apply();
					});
				}
			})();
		}
	}
}
